/**
 * Tiny pub/sub used to trigger the post-wizard "completing setup"
 * transition from anywhere (currently the policies step's Continue
 * button — was the branding step before that step was retired) and
 * have it rendered at the top of the React tree (App.jsx), so the
 * loader survives the wizard route unmounting when the post-Continue
 * navigation fires.
 *
 * Why not pass a callback through context? The Continue handler in
 * the wizard's final step calls navigate() immediately after
 * triggering the loader. That step (and any context provider scoped
 * beneath the wizard route) tears down right after — a portal'd
 * loader rendered from inside the step would unmount mid-animation.
 * Hoisting state to a stable mount point in App.jsx, driven by this
 * trivial pub/sub, sidesteps that entirely.
 */

let listeners = []

export function triggerSetupCompletingTransition() {
  listeners.forEach((fn) => {
    try { fn() } catch { /* swallow — one bad listener mustn't break others */ }
  })
}

export function subscribeSetupCompletingTransition(fn) {
  listeners.push(fn)
  return () => {
    listeners = listeners.filter((l) => l !== fn)
  }
}
